// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarHoverHighlightController from "./calendar_hover_highlight_controller"
application.register("calendar-hover-highlight", CalendarHoverHighlightController)

import CalendarEventHighlightController from "./calendar_event_highlight_controller"
application.register("calendar-event-highlight", CalendarEventHighlightController)

import CalendarSelectController from "./calendar_select_controller"
application.register("calendar-select", CalendarSelectController)

import ScheduleSelectController from "./schedule_select_controller"
application.register("schedule-select", ScheduleSelectController)

import IndexController from "./index_controller"
application.register("index", IndexController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScheduleFormController from "./schedule_form_controller"
application.register("schedule-form", ScheduleFormController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import EmailListController from "./email_list_controller"
application.register("email-list", EmailListController)
